import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import potonganService from "../../../services/ref/potonganService";
import Cookies from "js-cookie";

export const initialState = {
    loading_potongan: false,
    data_potongan: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPotongan = createAsyncThunk('potongan/data',async (data, { rejectWithValue }) => {
    try {
        const response = await potonganService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('potongan/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await potonganService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('potongan/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await potonganService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('potongan/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await potonganService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const potonganSlice = createSlice({
    name: 'potongan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_potongan = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPotongan.fulfilled, (state, action) => {
                state.loading_potongan = false
                state.data_potongan = action.payload??[]
            })
            .addCase(getDataPotongan.pending, (state) => {
                state.loading_potongan = true
            })
            .addCase(getDataPotongan.rejected, (state, action) => {
                state.loading_potongan = false
                state.data_potongan = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_potongan = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_potongan = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_potongan = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = potonganSlice.actions

export default potonganSlice.reducer
